import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  PerformanceAnalyticsEvaluationsIcon,
  PerformanceAnalyticsTalentIcon,
  PerformanceAnalyticsHistoricIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const PerformanceAnalyticsScreenSelector = () => {

  const data = [
    {
      name: getLocalizedString("performanceAnalyticsEvaluations"),
      icon: <PerformanceAnalyticsEvaluationsIcon />,
      path: paths.performanceAnalyticsEvaluations,
    },
    {
      name: getLocalizedString("performanceAnalyticsTalent"),
      icon: <PerformanceAnalyticsTalentIcon />,
      path: paths.performanceAnalyticsTalent,
    },
    {
      name: getLocalizedString("performanceAnalyticsHistoric"),
      icon: <PerformanceAnalyticsHistoricIcon />,
      path: paths.performanceAnalyticsHistoric,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("performanceAnalytics")}
      data={data}
    />
  );
}

export default PerformanceAnalyticsScreenSelector;
